<template>
    <div style="overflow: hidden;">
        <div class="container" ref="container">
            <img src="@/assets/home-three-icon2.png" />
        </div>
        <div class="container1">
            <div>
                <h1 class="wow animate__lightSpeedInLeft" data-wow-delay="0.1s">a difference</h1>
                <h3 class="wow animate__lightSpeedInLeft" data-wow-delay="0.2s">how did we make a difference?</h3>
            </div>
            <img src="@/assets/footerview/footer-two-icon1.png" />
            <div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.1s">
                    <h5>Design</h5>
                    <p>A full-funnel acquisition and conversion strategy was executed, combining targeted advertising,
                        influencer partnerships, and direct engagement tactics like email marketing, push notifications,
                        and in-app popups.</p>
                </div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.2s">
                    <h5>Content Creation</h5>
                    <p>Behind-the-scenes footage, short-form videos, and professional graphic designs were created to
                        capture and retain user interest, enriching the overall strategy.</p>
                </div>
            </div>
        </div>
        <div class="container2">
            <div>
                <div><img src="@/assets/footerview/footer-two-icon2.png" width="100%" /></div>
                <div>
                    <h3 class="wow animate__fadeInRight">The Client</h3>
                    <p class="wow animate__fadeInRight" data-wow-delay="0.1s">On Air Events is a dynamic platform that
                        offers users an immersive experience in the world of virtual and hybrid events. The platform
                        brings together the convenience of virtual connectivity and the thrill of live events, creating
                        unforgettable experiences for users across the globe.</p>
                </div>
            </div>

            <div>
                <div><img src="@/assets/footerview/footer-two-icon3.png" width="100%" /></div>
                <div>
                    <h3 class="wow animate__fadeInLeft">The Solution</h3>
                    <p class="wow animate__fadeInLeft" data-wow-delay="0.1s">MYD has developed a Full-Funnel Acquisition
                        and Conversion Strategy and enriched the overall strategy with engaging content creation.</p>
                </div>
            </div>
        </div>

        <div class="container3">
            <div><img src="@/assets/footerview/footer-two-icon4.png" width="70%" /></div>
            <div>
                <div v-for="(item, index) in accordionItems" :key="index" class="accordion-item"
                    :class="{ 'active': activeIndex === index }" @click="toggleAccordion(index)">
                    <div class="accordion-header">
                        <h3>{{ item.title }}</h3>
                    </div>
                    <div class="accordion-content" ref="accordionContents">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container4">
            <div>This case study exemplifies how a comprehensive and well-executed strategy can drive significant growth
                in the competitive digital event platform market.</div>
            <div><img src="@/assets/footerview/footer-two-icon5.png" /></div>
        </div>
        <div><img src="@/assets/footerview/footer-two-icon6.png" width="80%" /></div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';

const container = ref(null);
let observer = null;

const handleIntersection = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('clip-path-effect');
        } else {
            entry.target.classList.remove('clip-path-effect');
        }
    });
};

onMounted(() => {
    observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.1 // 当元素 10% 进入视口时触发
    });
    if (container.value) {
        observer.observe(container.value);
    }
});

onUnmounted(() => {
    if (observer && container.value) {
        observer.unobserve(container.value);
    }
});

const activeIndex = ref(null);
const accordionContents = ref([]);

const accordionItems = [
    {
        title: 'User Base Expansion',
        content: 'The strategic approach taken by On Air Events was a hit, leading to astounding success. By effectively blending various marketing tactics, they achieved an 88% surge in their user base, marking a significant milestone in their growth journey.'
    },
    {
        title: 'Conversion And Loyalty',
        content: 'On Air Events’ dedicated approach towards improving conversion rates was highly effective, resulting in a steep 30% increase in this critical area. Simultaneously, their efforts to enhance customer loyalty didn’t go unnoticed. They saw the rate of repeat purchases climb by over 11%, further cementing their position in the digital event market.'
    },
];

const toggleAccordion = async (index) => {
    if (activeIndex.value === index) {
        activeIndex.value = null;
    } else {
        activeIndex.value = index;
    }
    await nextTick();
    setAccordionHeight(index);
};


const setAccordionHeight = (index) => {
    accordionContents.value.forEach((content, i) => {
        if (i === index && activeIndex.value === index) {
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            content.style.maxHeight = '0px';
        }
    });
};
</script>

<style lang="less" scoped>
.container {
    background-image: url("../../assets/footerview/footer-two-bg.png");
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
    position: relative;

    &.clip-path-effect {
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 75%);
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 75%);
    }

    >img:nth-child(1) {
        width: 15vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.container1 {
    position: relative;

    >div:nth-child(1) {
        text-align: left;
        text-transform: uppercase;

        h1 {
            color: rgba(10, 15, 56, .1);
            letter-spacing: 10px;
            font-size: 5vw;
            margin: 0px;
            padding: 0px;
            margin-top: -45px;
        }

        h3 {
            font-size: max(2vw, 14px);
            margin: 0px;
            padding: 0px;
            margin-top: -55px;
            margin-left: 20px;
        }
    }

    >img:nth-child(2) {
        position: absolute;
        right: 3%;
        width: 18%;
        transform: translateY(-65%);
    }

    >div:nth-child(3) {
        display: flex;
        flex-wrap: wrap;
        gap: 3%;
        margin: 15% 10% 10% 10%;

        >div {
            flex: 1;
            min-width: 200px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
            padding: 3% 2%;
            margin-bottom: 20px;
            color: #97a4be;
            font-weight: 300;
            line-height: 1.5;

            >h5 {
                color: #233148;
                font-size: max(1.5vw, 12px);
                margin: 3% 0%;
                text-transform: uppercase;
            }
        }
    }
}

.container2 {
    >div {
        display: flex;
        flex-wrap: wrap;
        background-color: #f5f6fa;
        text-align: left;
        font-family: Space Grotesk, sans-serif !important;

        >div:nth-child(1) {
            flex: 2;
            min-width: 300px;
        }

        >div:nth-child(2) {
            flex: 3;
            min-width: 300px;
            padding: 3%;
        }

        h3 {
            font-weight: 400;
            font-size: max(2vw, 14px);
        }

        p {
            line-height: 1.7;
            color: #1a2e42;
            font-weight: 300;
        }
    }

    >div:nth-child(2) {
        background-color: #fff;
        flex-direction: row-reverse;
    }
}

.container3 {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin: auto;

    >div {
        flex: 3;
        padding-top: 5%;
        min-width: 300px;

        img {
            width: 80%;
            z-index: 100;
            position: relative;
        }
    }

    >div:nth-child(2) {
        flex: 4;
        position: relative;
        z-index: 101;
        text-align: left;

        .accordion-item {
            background-color: #fff;
            color: #172d43;
            border: 1px solid #ddd;
            margin-bottom: 10px;
            cursor: pointer;
            padding: 3%;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
            transition: background-color 0.3s, color 0.3s;

            &.active {
                background-color: #0a0f38;
                color: #fff;
            }

            .accordion-header {
                >h3 {
                    margin: 0px;
                }
            }

            .accordion-content {
                overflow: hidden;
                max-height: 0;
                transition: max-height 0.3s ease-out;

                p {
                    padding: 20px 0px 10px 0px;
                    margin: 0px;
                }
            }
        }
    }
}

.container4 {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 99;

    &::before {
        position: absolute;
        width: 100%;
        height: 100%;
        top: -200px;
        left: 0;
        content: "";
        background-color: #f5f6fa;
        transform: skewY(10deg);
        z-index: 10;
    }

    color: #172d43;
    line-height: 1.5;
    padding: 7%;
    gap: 2%;
    font-weight: 400;
    font-size: max(2vw, 14px);
    text-align: left;

    >div {
        flex: 3;
        position: relative;
        z-index: 100;
        min-width: 300px;

        >img {
            width: 100%;
        }
    }

    >div:nth-child(2) {
        flex: 4;
    }
}

@media all and (max-width:600px) {
    .container {
        min-height: 0px;
        aspect-ratio: 5/9 !important;

        >img:nth-child(1) {
            top: 15%;
            left: 50%;
            width: 150px;
        }
    }

    .container1 {
        position: relative;

        >div:nth-child(1) {
            text-align: left;
            text-transform: uppercase;

            h1 {
                margin-top: -45px;
            }

            h3 {
                margin-top: -10px;
                margin-left: 0px;
            }
        }

        >img:nth-child(2) {
            position: absolute;
            right: 3%;
            width: 200px;
            transform: translateY(-110%);
        }
    }

    .container2 {
        width: 90%;
        margin: auto;
    }
}
</style>